import { ILogUserData } from 'schemas';
import { ELogType } from 'types';

import { INormaliseUserProps } from '../interfaces';

export const getLogSubject = ({
  type,
  client,
  worker,
  manager,
}: INormaliseUserProps): ILogUserData | null => {
  switch (type) {
    case ELogType.ACHIEVEMENT_ASSIGNED:
    case ELogType.CLIENT_AUTHORIZED_FROM_HOST:
    case ELogType.CLIENT_SESSION_UNPAUSED_AUTO:
    case ELogType.CLIENT_SESSION_FINISHED:
    case ELogType.CLIENT_SESSION_PAUSED:
    case ELogType.CLIENT_SESSION_PROLONGED:
    case ELogType.CLIENT_SESSION_STARTED:
    case ELogType.CLIENT_SESSION_UNPAUSED:
    case ELogType.CLUB_COMMENT_CREATED:
    case ELogType.DEPOSIT_ADDED_ONLINE:
    case ELogType.HOST_ADMIN_CALLED:
    case ELogType.USER_REGISTERED:
    case ELogType.SEND_VERIFY_CODE:
    case ELogType.SEND_RESET_CODE:
    case ELogType.USER_DEPOSIT_TRANSFERRED:
    case ELogType.PROMO_CODE_USED:
      return client;
    case ELogType.NEWS_DELETED:
    case ELogType.NEWS_CREATED:
    case ELogType.NEWS_UPDATED:
    case ELogType.DEBT_ACTIVATED:
      return manager;
    case ELogType.CLIENT_SESSION_HOST_CHANGED:
    case ELogType.CLUB_CREATED:
    case ELogType.GOOD_LOW_STOCK_THRESHOLD_REACHED:
    case ELogType.HOST_SESSION_STARTED:
    case ELogType.HOST_SESSION_FINISHED:
    case ELogType.HOST_SWITCHED_GROUP:
    case ELogType.POST_PAYMENT_CANCELED:
      return null;

    default:
      return worker;
  }
};
